<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Venta</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <date-picker
            v-model="fecha"
            label="Fecha"
            max-today
          ></date-picker>
          <month-picker
            v-model="periodo"
            readonly
          ></month-picker>
          <v-text-field
            :value="precio | formatToTwoDecimals"
            readonly
            label="Precio"
            prepend-icon="mdi-currency-usd"
            color="primary"
          ></v-text-field>
          <v-divider class="my-2"></v-divider>
          <productos-select
            v-model="productoId"
            @coeficiente="onCoeficiente"
          ></productos-select>
          <v-text-field
            v-model="glosa"
            :disabled="!(precioId > 0)"
            label="Observaciones"
            prepend-icon="mdi-text"
            color="primary"
            @keydown.enter="onSubmit"
          ></v-text-field>
          <v-text-field
            v-if="coeficiente === 1"
            v-model="litros"
            :disabled="!(precioId > 0)"
            label="Litros"
            prepend-icon="mdi-water"
            color="primary"
            type="number"
            @keydown.enter="onSubmit"
            @input="handleInputLitros"
          ></v-text-field>
          <v-text-field
            v-if="coeficiente === 1"
            v-model="cantidad"
            :disabled="!(precioId > 0)"
            label="Kilos"
            prepend-icon="mdi-weight-kilogram"
            color="primary"
            type="number"
            :rules="rules.cantidad"
            @keydown.enter="onSubmit"
            @input="handleInputCantidad"
          ></v-text-field>
          <v-text-field
            v-if="coeficiente > 1"
            v-model="cantidadCoeficiente"
            :disabled="!(precioId > 0)"
            label="Cantidad"
            prepend-icon="mdi-propane-tank"
            color="primary"
            type="number"
            :rules="rules.cantidad"
            @keydown.enter="onSubmit"
            @input="handleInputCantidadCoeficiente"
          ></v-text-field>
          <importe-input
            :value="importe"
            :disabled="!(precioId > 0) || isSubmitting"
            @input="handleInputImporte"
            @enter="onSubmit"
          ></importe-input>
          <v-footer>
            <v-btn
              :disabled="!updatable && !$can('debitos.store')"
              color="primary"
              @click="onSubmit"
              :loading="loading"
            >
              Registrar
            </v-btn>
          </v-footer>
        </v-container>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PrecioMixin from '@/mixins/Precios';
import PeriodoMixin from '@/mixins/Periodo';
import MonthPicker from '@/components/MonthPicker'
import DatePicker from '@/components/DateInput'
import ImporteInput from '@/components/ImporteInput'
import ProductoSelect from '@/pages/productos/SelectComponent'
import PreciosVigentesSelected from '@/pages/precios_vigentes/SelectedComponent'
export default {
  name: 'DebitosCreateComponent',
  mixins: [PeriodoMixin, PrecioMixin],
  components: {
    'date-picker': DatePicker,
    'month-picker': MonthPicker,
    'productos-select': ProductoSelect,
    'precios-vigentes-selected': PreciosVigentesSelected,
    'importe-input': ImporteInput
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean
  },
  data () {
    return {
      focusGas: false,
      kilogramos: null,
      hoy: null,
      precio: 0,
      importeInterno: 0, // Nuevo dato para el importe
      litros: 0,// Densidad = masa / volumen,
      isSubmitting: false,
      coeficiente: 1,
      cantidadCoeficiente: 0,
    }
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
    this.onLimpiar()
  },
  mounted () {
    this.cuentaId = this.selectedId
    this.hoy = this.$moment().format('YYYY-MM-DD')
    // this.onLimpiar()
  },
  computed: {
    ...mapGetters('Cuentas', ['selectedId']),
    ...mapGetters('Debitos', ['edited', 'rules', 'loading', 'updatable']),
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    fecha: {
      get () {
        return this.edited.fecha
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          fecha: value
        })
      }
    },
    periodo: {
      get () {
        return this.edited.periodo
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          periodo: value
        })
      }
    },
    cantidad: {
      get () {
        return this.edited.cantidad
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cantidad: value
        })
      }
    },
    importe: {
      get () {
        return this.edited.importe
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          importe: value
        })
      }
    },
    glosa: {
      get () {
        return this.edited.glosa
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          glosa: value
        })
      }
    },
    precioId: {
      get () {
        return this.edited.precio_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          precio_id: value
        })
      }
    },
    productoId: {
      get () {
        return this.edited.producto_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          producto_id: value
        })
      }
    },
    cuentaId: {
      get () {
        return this.edited.cuenta_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cuenta_id: value
        })
      }
    },
  },
  watch: {
    dialog(newVal) {
      this.onLimpiar();
    },
    async fecha(newVal) {
      if (newVal) {
        this.periodo = await this.periodoFechaTo(newVal);
        const precio = await this.precioByVigencia(newVal);
        if(precio && precio.id > 0) {
          this.precioId = precio.id;
          this.precio = precio.pleno;
        }
      } else {
        this.precio = 0;
        this.periodo = null;
        this.precioId = null;
      }
      this.cantidad = 0;
      this.importe = 0;
    },
    selectedId(newValue) {
      this.cuentaId = newValue
    },
  },
  methods: {
    ...mapActions('Debitos', ['onSave', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Debitos', ['setEdited']),
    async onLimpiar() {
      this.onClearEdited()
      this.onClearSelected()
      this.productoId = 1;
      this.cuentaId = await this.selectedId;
      this.fecha = await this.$moment().format('YYYY-MM-DD');
      this.litros = 0;
    },
    onSubmit(event) {
      event.preventDefault();
      // Si ya estamos enviando, salimos de la función
      if (this.isSubmitting || !this.fecha) {
        return;
      }
      this.isSubmitting = true; // Establecer la bandera en true

      this.onSave().then(response => {
        this.onLimpiar()
        this.$store.dispatch('Transacciones/onFetch');
        this.$store.dispatch('Cuentas/onRefresh');
        this.dialog = false
      })
      .finally(() => {
        this.isSubmitting = false; // Restablecer la bandera a false al finalizar
      });
    },
    onClose(event) {
      event.preventDefault()
      this.dialog = false
    },
    handleKeyboard(event) {
      if(event.key === 'Enter' && !event.ctrlKey) {
        this.onSubmit(event)
      }
      else if(event.altKey && event.key == 'k') {
        event.preventDefault()
        this.focusGas = true
      }
    },
    handleInputLitros() {
      const litros = parseFloat(this.litros);
      if (litros > 0) {
        this.cantidad = parseFloat((litros * 0.51));
        this.importe = parseFloat(this.cantidad * this.precio);
      }
    },
    handleInputCantidad(newVal) {
      const cantidad = parseFloat(newVal);
      if (cantidad > 0) {
        this.importe = parseFloat(cantidad * this.precio);
        this.litros = parseFloat((cantidad / 0.51));
      }
    },
    handleInputCantidadCoeficiente(newVal) {
      const cantidad = parseFloat(newVal);
      if (cantidad > 0) {
        this.cantidadCoeficiente = cantidad;
        this.cantidad = cantidad * this.coeficiente;
        this.importe = this.cantidad * this.precio;
      }
    },
    handleInputImporte(newVal) {
      //
    },
    onCoeficiente(newVal) {
      this.coeficiente = parseInt(newVal)
      this.importe = this.cantidad * this.precio;
    }
  },
}
</script>
